import styled from 'styled-components';
import { para1 } from '../theme/GlobalStyle';

export const AuthorContainer = styled.div`
  padding: 70px 0 60px;

  .author-videos {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;

    & p {
      flex-basis: 47%;

      & iframe {
        width: 100%;
      }
    }

    @media (max-width: 824px) {
      flex-direction: column;
      align-items: center;

      & p {
        width: 100%;
      }
    }
  }
`;

export const PostContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  & > li {
    flex-basis: 30%;
    margin: 0 3% 30px 0;
  }
  @media (max-width: 824px) {
    li.news {
      flex-basis: 100%;
    }
  }
`;
export const Title = styled.h3`
  margin: 40px 0;
  color: ${(props) => props.theme.color.black};
  font-size: 32px;
  ${(props) => props.theme.fontStyleBold}
`;

export const AuthorDescription = styled.div`
  margin: 30px 0;
  display: flex;
  justify-content: space-between;
  figure {
    flex-basis: 30%;
    margin: 5px 20px 0 0;
    & img {
      border: 1px solid ${(props) => props.theme.color.borderLight};
      aspect-ratio: 1 / 1;
      object-fit: cover;
    }
  }
  div {
    flex-basis: 68%;
    p {
      margin-bottom: 15px;
      color: ${(props) => props.theme.color.textLight};
      ${para1}
    }
  }
  @media (max-width: 824px) {
    flex-wrap: wrap;
    figure {
      margin: 0 0 20px;
      flex-basis: 100%;
    }
    div {
      flex-basis: 100%;
    }
  }
`;

export const SocialLink = styled.ul`
  padding: 15px 0;
  border-top: 1px solid ${(props) => props.theme.color.borderLight};
  border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
  margin: 30px 0 0;
  display: flex;
  align-items: center;
  li {
    margin-right: 10px;
    display: flex;
    align-items: flex-start;
    flex-basis: 20%;
  }
  li span {
    display: inline-block;
    margin-right: 10px;
    color: ${(props) => props.theme.color.bgPrimary};
    font-size: 24px;
  }
  li a {
    color: ${(props) => props.theme.color.textLight};
    font-size: 16px;
    line-height: 32px;
    text-decoration: underline;
    @media (min-width: 1024px) {
      &:hover {
        color: ${(props) => props.theme.color.bgPrimary};
      }
    }
  }
  @media (max-width: 995px) {
    li {
      margin: 0;
      flex-basis: 35%;
    }
  }
  @media (max-width: 768px) {
    li {
      margin: 0;
      flex-basis: 50%;
      padding: 0 8%;
    }
  }
`;
